export default {
  message: 'こんにちは i18n !!',
  welcome: 'ようこそ',
  totalAssetValue: '総資産価値', //  총 보유 자산
  welcome_sir: '',
  errorServer: 'インターネット接続が不安定です。後でもう一度お試しください。',
  requiredMessage: 'この項目は必須です。',
  close: '閉じる',
  back: '戻る',
  cancel: 'キャンセル',
  register: '登録',

  login: {
    id: 'アカウント名（メールアドレス）',
    password: 'パスワード',
    autoLogin: 'ログイン状態を維持',
    signup: '新規登録',
    forgot: 'パスワードをお忘れですか？',
    login: 'ログイン',
    errors: 'ログインIDまたはパスワードが無効です。',
    requiredMessage: 'この項目は必須です。',
    emailMessage: '無効なID（メールアドレス）です。',
  },
  signup: {
    id: 'ID（必須）',
    idPlaceholder: 'メールアドレスを入力してください。',
    password: 'パスワード（必須）',
    passwordPlaceholder: 'パスワードを入力してください。',
    confirmPassword: 'パスワード確認（必須）',
    refferalCode: '紹介コード',
    refferalCodePlaceholder: '紹介コードを入力してください。',
    back: '戻る',
    signup: '新規登録',
    requiredMessage: 'この項目は必須です。',
    emailMessage: '無効なID（メールアドレス）です。',
    passwordMessage: 'パスワードが一致しません。',
    regexMessage:
      'パスワードは8文字以上で、大文字1文字、数字1文字、特殊文字1文字を含む必要があります。',
    duplicateMessage: 'このメールアドレスは既に使用されています。',
    recommendMessage: '無効な紹介コードです。',
    withdrawMessage: '退会したアカウントは1ヶ月後に再登録可能です。',
  },
  password: {
    title: 'パスワードリセット申請',
    email: 'メールアドレス',
    emailPlaceholder: 'メールアドレスを入力してください。',
    request: '申請',
    invalidMessage: '無効なID（メールアドレス）です。',
    tokenMessage: '無効なトークンです。',
    desc1:
      'パスワードをリセットするための認証コードがメールで送信されました。',
    desc2:
      'メールを確認してパスワードリセット手続きを進めてください。認証コードは5分間のみ有効です。',
    password: 'パスワード',
    passwordPlaceholder: 'パスワードを入力してください。',
    confirmPassword: 'パスワード確認',
    verificationCode: '認証コード',
    verificationCodePlaceholder: '認証コードを入力してください。',
    submit: '送信',
    successMessage: 'パスワードが正常に変更されました。',
  },
  update: {
    title: 'アップデート予定',
    desc: '機能がアップデートされます。',
  },
  home: {
    myWalletAddress: '私のウォレットアドレス',
    copyClipboard: 'クリップボードにコピー',
    copySuccess: 'ウォレットアドレスがクリップボードにコピーされました。',
    copyFail: 'コピーに失敗しました。',
    popup: {
      title: '{num} Paycamロトの当選番号',
      noPopup: `1週間表示しない`,
      detail: '詳細を見る',
    },
  },
  nft: {
    purchasePrice: '購入価格', // 구매가
    quantity: '数量', // 구매 수량
    qty: '個', // 단위(개)
    registration: '登録', // '등록하기'
    regConfirm: '登録しますか？', // 등록하시겠습니까? ,

    regCardMsg: 'カードのシリアル番号を登録してください。',
    serialNumber: 'シリアル番号',
  },
  send: {
    smsgPlaceholder: 'メモ',
    smsgLabel: 'メモ',
    coinLabel: 'コインを選択',
    coinPlaceholder: '出金するコインを選択してください。',
    availableAmount: '出金可能金額',
    pliDesc:
      'イベントで支払われたPLIは、スワップリクエストでPLPに切り替えた後にのみ出金できます。',
    amountLabel: '金額',
    amountPlaceholder: '出金金額を入力してください。',
    addressLabel: 'ウォレットアドレス',
    addressPlaceholder: '出金先アドレスを入力してください。',
    feeLabel: '取引手数料',
    slow: '遅い',
    average: '普通',
    fast: '速い',
    about: '約',
    feeCaution: '低い手数料（ガス価格）は取引の失敗を引き起こす可能性があります。',
    expactFee: '予想手数料',
    send: '出金申請',
    refreshModal: {
      message: '手数料（ガス）データの受信に失敗しました。',
      home: 'ホームに戻る',
      reload: '手数料（ガス）データを再受信',
    },
    confirmModal: {
      amount: '金額',
      address: '出金先アドレス',
      message: '出金しますか？',
      cancel: 'キャンセル',
      send: '送信',
    },
    successModal: {
      title: '出金申請が送信されました',
      desc: '合計金額',
      confirm: '出金申請結果',
    },
    authModal: {
      title: '認証',
      message: '認証コードが送信されました（数字のみ）。',
      code: '認証コード（数字のみ）',
      checkMsg: '認証コードを確認してください',
      // confirm: 'Withdrawal request Result' ,
      cancel: 'キャンセル',
      confirm: '確認',
    },
    amountRulesRequired: '金額を入力してください。',
    amountRulesConfirmed: '金額を確認してください。',
    addressRulesRequired: '出金先アドレスを入力してください。',
    addressRulesConfirmed: '無効な出金先アドレスです。',
    smsgRules20length: '10文字まで入力できます。',
    coinRulesRequired: 'コインを選択してください。',
    feeMessage: '出金手数料が不足しています。',
    insufficientMessage: '金額を確認してください。',
    failMessage: '資金の出金に失敗しました。',
    sendBtn: '送信',
    targetNotFound: 'ターゲットが見つかりません。',
    phoneNumber: '電話番号',
    walletAddress: 'ウォレットアドレス',
  },
  gnb_winResult: '私の結果履歴',
  gnb_saveNumber: '保存された番号',
  gnb_preRound: '前回の結果',
  gnb_winCriteria: '当選基準',
  lotto: {
    imgBanner: '@/assets/img/event-card.png',
    todayNumber: '今日の無料ロト番号',
    getLottoNumber: '無料ロトチケットを取得',
    withPaypal: 'PayPalで支払う',
    purchase: '購入',

    confirmModal: {
      // 로또 신청 팝업
      txt_check: 'カンボジアロトの無料支払いに同意します。', //캄보디아 로또 무료 지급에 동의합니다
      imgBanner: '@/assets/img/event-poster.png',
      amount: '番号を選択',
      getFree: '無料ロトチケットを取得',
    },
    confirmModalResult: {
      // 신청 결과 팝업
      confirm: '確認', // 확인하기
      close: '閉じる', // 닫기
      ok1: '無料カンボジアロトが支払われました。',
      ok2: '支払われたロトは[当選結果]ページで確認してください。', //무료 캄보디아 로또가 지급되었습니다. 지급된 로또는 [당첨결과] 페이지에서 확인하세요
      err: '今日はすでにイベントに応募しました。', // 오늘은 이미 이벤트에 응모하셨습니다
      failMessage: '購入に失敗しました。後でもう一度お試しください。',
      timeoutMessage: '現在ロトチケットは販売していません。',
      endMessage: '無料ロトイベントは終了しました。',
    },
    selectNumModal: {
      txt_choseNumber: '{num}個の番号を選択してください。', // ex 6개의 번호를 선택하세요
      reset: 'リセット', //초기화
      auto: '自動',
      submit: '送信', // 선택완료
      modify: '修正',
      errorMessage: '6個を超える番号を選択できません。',
      countMessage: '6個の番号を選択する必要があります。',
    },
    gameNum: '{num} paycam ロト',
    congratulation: 'おめでとうございます！',
    prize: '{num}等',
    win: '当選',
    lose: '落選',
    noResult: '抽選予定',
    noOrder: '購入履歴なし',
    matchBonus: 'ボーナス番号を含む',
    match: '6個中{num}個一致',
    prizeUnit: 'ウォン',
    prizeNum: '{num}',
    lottoOrderDesc: '無制限に購入可能',
    lottoOrderBtn: 'ロト購入はこちら',
    orderModal: {
      message: '1枚のロトチケットは{price}PLPまたは{price}PLIです。',
      manual: '手動選択',
      auto: '自動選択',
      unlimit: '無制限購入',
      manualDesc: 'ロト番号を自分で選択できます。',
      autoDesc: '自動選択されたロト番号を購入できます。',
      next: '次へ',
    },
    attendBtn: '出席チェック',
    attendMessage1: '完了',
    attendMessage2: `[CONFIG]タブの「毎日の出席チェック」ボタンで確認できます。`,
  },
  myNum: {
    //lotto/mynumber
    modify: '修正',
    noMyNum: '保存された番号がありません。',
    deleteModal: {
      message: '保存された番号を削除しますか？',
      cancel: 'キャンセル',
      submit: '削除',
      confirmMessage: '保存された番号が削除されました。',
      failMessage: '番号の削除に失敗しました。',
    },
    confirmMessage: '番号が正常に登録されました。',
    failMessage: '番号の登録に失敗しました。',
  },
  order: {
    //lotto/order
    autoSelection: '自動選択',
    autoInput1: '購入 ',
    autoInput2: ' 枚',
    inputPlaceholder: '数値を入力',
    exceedMessage: '* 購入数が超過しました。',
    manualSelection: '手動選択',
    savedNum: '保存された番号',
    purchaseLotto: 'ロト購入', // 로또 구매
    reset: 'リセット', // 초기화
    submit: '送信', //등록
    modify: '修正', // 수정
    purchase: '購入', //무료로 로또 받기
    modalTitle: '購入方法',
    buyTo: '{name}に購入',
    holding: '保有 ',
    quantity: '購入数量',
    ticket: ' 枚',
    price: '価格',
    fee: '手数料',
    total: '合計',
    remaining: '残高',
    next: '次へ',
    toBeOpen: '後でサポートされます。',
    paypalDesc: '* PayPal支払い機能は後でサポートされます。',
    feeModal: {
      title: '手数料情報',
      text1: 'ETHガスステーションに基づき「速い」速度を適用します。',
      text2:
        '低手数料ポリシーにより、取引失敗の可能性があります。',
      text3: 'Fame Walletはそれに対して責任を負いません。',
    },
    myNumModal: {
      title: '保存された番号',
      message: '保存された番号がありません。',
      submit: '送信',
    },
    paypalModal: {
      confirm: 'ロト購入を進めますか？', // 로또 구매를 진행하시겠습니까?
      total: '合計', //총 수량
      cancel: 'キャンセル', // 취소
      submit: '送信', // 구매하기
    },
    chooseMessage: '購入する番号を選択してください。',
    freeMessage: '無料ロトチケットは1枚のみ利用可能です。',
    successTitle: 'ロト購入完了',
    successText1: '購入したロト番号は',
    successText2: '[当選完了]ページで確認できます。',
    successBtn: 'ロトページに移動',
  },
  pay: {
    //pay
    pay: '支払い', // 결제
    updateSoon: 'アップデート予定', // 업데이트 예정
    txt_update: '"支払い"機能がアップデートされます。', // pay 기능은 업데이트 예정입니다.
    scan_do_it: 'barcode on&nbsp<a href="/#/buy">キオスクスキャン</a>&nbsp do it.', // '키오스크에 바코드를 스캔 하세요.'
  },
  cards: {
    OwnerInformation: '所有者情報',
    LastName: '姓',
    FirstName: '名',
    eMail: 'メール',
    Mobile: '携帯電話',
    BirthDay: '生年月日',
    Gender: '性別',
    NationalityCode: '国籍コード',
    IDNumber: 'ID番号',

    CardInformation: 'カード情報',
    CardNumber: 'カード番号',
    Balance: '残高',
    Amount: '金額',
    Charged: 'チャージ済み',
    RecommendInformation: '推薦情報',
    ReferCode: '紹介コード',
  },
  eventGame: {
    congratulations: 'おめでとうございます！',
    clickAchieved: '{tier}クリック達成！',
    requestReward: '報酬をリクエストしますか？',
    request: 'リクエスト',
    walletConnect: 'ウォレット接続',
    selectWallet: '接続するウォレットを選択してください。',
    manualAddress: '手動ウォレットアドレス（任意）',
    manualAddressPlaceholder: '0xで始まるアドレスを入力',
    useManualAddress: '手動ウォレットアドレスを使用',
    currentAddress: '現在接続されているアドレス: {address}',
    cancel: 'キャンセル',
    remaining: '残り {remaining} / {threshold} クリック',
    totalReward: '総報酬',
    usedOut: '使用済み（出金済み）',
    availableConvert: '変換可能',
    loadingReward: '報酬ポイントを読み込み中...',
    tooltipReward: '使用済み（出金済み）: {out} / 変換可能: {late}',
    wallet: 'ウォレット',
    walletConnectLogin: 'ウォレット接続＆ログイン',
    connectWallet: 'ウォレット接続',
    playGame: 'ゲームプレイ',
    signature: '署名',
    rewardRequest: '報酬リクエスト（{tier}達成）',
    rewardWaiting: '報酬リクエストが保留中です。報酬リクエストを完了してください。',
    signFirst: 'まずゲームプレイ（署名）ボタンで署名してください。',
  },
  config: {
    TradeHistory: '取引履歴',

    Notice: 'お知らせ',
    refferalCode: '紹介コード', // 'refferal code'
    copyMessage: '紹介URLが正常にコピーされました。',
    shareMessage: '[web3pays]今すぐ登録して125PLIを取得！', //이 메세지는 추후 변경 예정
    shareSuccess: '共有が完了しました。',
    shareFail: '共有に失敗しました。',
    lockUp: 'ロックアップ',
    noLockUp: 'ロックアップ中のコインはありません。',
    swapCoin: 'コインスワップ',
    attendanceCheck: '毎日の出席チェック',
    deposit: '入金',
    withdraw: '出金',
    pliHistory: 'PLI履歴',
    performance: '私の実績',
    transHistory: '取引履歴',

    store: '店舗', // 매장
    storeNone: '店舗はありません。',
    recommender: '推薦者', // 추천인
    recommenderNone: '推薦者なし', // 추천인

    ReferralList: '紹介リスト', // 추천인목록
    PaymentHistory: '支払い履歴', // 결제이력
    PaymentHistoryNone: '支払い履歴がありません。',
    staking: 'ステーキング',
    copyReferralLink: '紹介リンクをコピー',
    referralLinkCopied: '紹介リンクが正常にコピーされました。',
    copyFailed: 'コピーに失敗しました。',

    logOut: 'ログアウト',
    language: '言語',
    submit: '送信',
    withdrawMessage1_1: 'アカウントを削除する場合は、',
    here: 'こちら',
    withdrawMessage1_2: 'をクリックしてください。',
    withdrawMessage2: 'アカウントを削除すると、',
    withdrawMessage3:
      'アカウント情報とともにすべてのPLIが破棄されます。',
    withdrawMessage4:
      '削除されたアカウントは1ヶ月後に再登録可能です。',
    withdrawMessage5: '本当に退会しますか？',
    withdraw: 'アカウント削除',
    withdrawComplete: 'アカウント退会が完了しました。',
    logoutMessage: '今すぐログアウトしますか？',
  },
  Notice: {
    tiker: 'お知らせ',
    title: 'お知らせ',
    lists: 'リスト',
    listsNone: '登録されたコンテンツはありません。',
    more: 'もっと見る',
  },
  attend: {
    attendanceCheck: '毎日の出席チェック',
  },
  history: {
    // config/history/eth
    more: 'もっと見る',
    callContract: 'コントラクト呼び出し', //  컨트랙트 호출
    noHistory: '履歴がありません。', // There is no history
    detail: '取引詳細',
    close: '閉じる',
  },
  recommend: {
    //config/recommend
    myPerformance: '私の実績 ', // 나의 실적
    genPromote1: '1世代推進',
    genPromote2: '2世代推進',
    paid: '支払済み',
    join: '加入', // 가입
    noReferrals: '紹介は登録されていません。', // No referrals have been signed up
    people: '',
    phone: '電話',
  },
  point: {
    //config/point
    join: '新規登録ボーナス', // 회원가입
    genPromote1: '世代推進',
    genPromote2: '世代推進',
    attend: '毎日の出席チェック',
    pli_out: 'PLIスワップリクエスト',
    pli_fee: 'PLIスワップ手数料',
    pli_lotto_order: 'ロト購入',
    pli_exchange_in: 'スワップで支払われたPLI',
    supporters_add: 'Paycamサポーターボーナス',
    supporters_del: 'Paycamサポーター回収',
    lottoGive: '賞金支払い',
    unpaid: '(未支払い)',
    paid: '(支払済み)',
    more: 'もっと見る',
    deposit: '入金',
    withdrawal: '出金',
    exchangeApplication: '両替申請',
    exchangeAmount: '両替数量',
    amountPlaceholder: '最小 10,000 PLI',
    amountMax: '最大',
    availablePli: '両替可能 PLI',
    fee: '手数料',
    totalAmount: '総両替額',
    includeFee: '(手数料含む)',
    close: '閉じる',
    successExchange: '両替申請完了',
    detailResult: '両替申請結果を見る',
    confirmMessage: '両替しますか？',
    cancel: 'キャンセル',
    submitExchange: '両替申請する',
    amountError: '10,000 以上両替可能です。',
    amountNull: '両替数量を入力してください。',
    insufficientError: '両替可能数量を確認してください。',
    xuserError: '両替申請が不可能です。',
  },
  swap: {
    //config/swap
    selectCoin: 'コインを選択', // Select Coin
    amount: 'スワップする金額', // Amount to be Swapped
    reset: 'リセット',
    requestSwap: 'スワップリクエスト',
    swapSuccess: 'スワップリクエストが正常に完了しました。',
    errCoin: 'スワップするウォレットを選択してください。', // Choose a wallet to swap
    errAmount: 'スワップする数量を入力してください。', // Enter the quantity to be swapped
    messageModal: {
      amountFail: '資金不足。',
      fail: 'コイン転送に失敗しました。',
      close: '閉じる',
    },
    successModal: {
      title: 'スワップリクエスト完了',
      desc: 'スワップ金額',
      confirm: 'スワップリクエスト詳細',
    },
  },
  staking: {
    period: '期間',
    days30: '30日',
    days60: '60日',
    days90: '90日',
    quantity: '数量',
    quantityPlaceholder: '数量を入力してください。',
    expectedValue: '予想価値',
    description: '現在のステーキングプログラムはAILabsが運営しています。\n同意する場合のみ進めてください。\n\nUMUCコイン預金ポリシー\n30日: 8%\n60日: 9%\n90日: 10%\n\nこれはエアドロップの形での追加支払いです。',
    stakingBtn: 'ステーキング',
    stakingStatus: '現在ステーキング中。',
    tradeHistory: '取引履歴',
    enterQuantity: 'ステーキングするトークンの数量を入力してください。',
    minQuantity: 'ステーキングトークンの数量は少なくとも{min}必要です。',
    checkAvailable: 'ステーキング可能なトークンの数量を確認してください。',
    success: 'ステーキングが成功しました。',
    checkQuantity: 'ステーキング可能なUMUC数量を確認してください。',
    failed: 'ステーキングに失敗しました。',
  },
  sms: {
    phone: '携帯電話',
    phonePlaceholder: '電話番号を入力してください。',
    codePlaceholder: '認証番号を入力してください。',
    codeBtn: '認証番号を受け取る',
    m01: '無効な電話番号です。',
    m02: '認証番号を送信しました。',
    m03: '認証番号は10分間有効です。',
    m04: "メッセージが届かない場合は、迷惑メールまたは拒否されたメッセージフォルダを確認してください。",
    m05: '有効な認証コードがあります。',
    m06: '既に登録されている携帯電話番号です。',
    m07: '当日の認証リクエストを超過しました。',
    m08: '翌日認証可能です。',
    m09: 'メール情報がありません。',
    m10: '認証番号の送信に失敗しました。もう一度お試しください。',
    m11: '認証が必要です。',
    m12: '携帯電話認証が確認されました。',
    m13: '一致する情報がありません。',
    m14: '認証番号が一致しません。',
    m15: '認証番号を送信できません。',
    m16: '認証番号を送信できません。',
  },
  verify: {
    title: '認証番号入力',
    desc1: '入力いただいた携帯電話番号に',
    desc2: '認証番号を送信しました。',
    desc3: '送信された認証番号を入力してください。',
    codePlaceholder: '受信した認証コードを入力してください',
    recommendPlaceholder: '紹介コード（任意）',
    serviceTerms: 'サービス利用規約',
    financeTerms: '電子金融取引利用規約',
    loginBtn: 'Login',
    confirmBtn: '確認',
    requiredCode: '認証コードを入力してください。',
    requiredService: 'サービス利用規約を確認してください。',
    requiredFinance: '電子金融取引利用規約を確認してください。',
    invalidToken: '認証番号が正しくありません。',
    tokenTimeout: '認証番号の有効時間が超過しました。',
  },
  common: {
    phoneEmailLabel: '携帯電話＆メール',
    walletAddressLabel: 'ウォレットアドレス',
    verificationCodeLabel: '認証番号',
    recommenderLabel: '紹介者',
    sendVerificationBtn: '認証番号送信',
    confirmBtn: '確認',
    verificationMismatchAlert: '認証リクエストの電話番号が異なります',
    verificationConfirmAlert: '認証コードを確認してください。',
    verificationSuccessAlert: '認証されました。',
    phoneNumberCheckAlert: '電話番号を確認してください',
    paymentAmountAlert: '決済金額を入力してください',
    paymentInfoAlert: '決済情報を再確認してください',
    paymentAvailableAlert: '決済可能金額を確認してください',
    retryLaterAlert: 'しばらくしてから再度お試しください',
    placeholderWon: 'ウォン',
    placeholderQty: '個',
  },
  card: {
    tradeType: {
      100: 'チャージ',
      110: '現金引出',
      120: '入金',
      121: '振替',
      150: '優先承認',
      151: '支払',
      200: '精算',
      300: '残高照会',
      500: '手数料',
    },
  },
  txHistory: {
    contractCall: 'コントラクト呼び出し',
  },
  staff: {
    staffLabel: 'スタッフ',
    adminLabel: '管理者',
  },
}
